const about = {
  title: '关于BB彩票平台',
  subtitle: '安全、正规、值得信赖的手机彩票购买平台',
  brandTitle: '品牌故事',
  brandContent1: 'BB彩票平台成立于2018年，是一家专注于移动互联网彩票服务的科技公司。我们致力于通过技术创新，为广大彩民提供安全、便捷、透明的线上购彩服务。',
  brandContent2: '自成立以来，BB彩票平台始终坚持"诚信为本、用户至上"的经营理念，已累计服务超过500万用户，完成超过1.2亿笔交易订单，累计兑付奖金超过89亿元，赢得了广大彩民的信赖与好评。',
  brandContent3: '平台持有国家相关部门颁发的合法经营资质，所有彩票销售均严格遵守国家法律法规，资金由第三方银行全程托管，确保每一笔交易的安全与透明。',
  missionTitle: '企业使命',
  missionContent: '让每一位彩民都能享受安全、便捷、透明的购彩体验，用科技力量推动彩票行业的健康发展。',
  valuesTitle: '核心价值观',
  valueIntegrity: '诚信为本',
  valueIntegrityDesc: '坚持合规经营，公开透明，对每一位用户负责。',
  valueInnovation: '技术创新',
  valueInnovationDesc: '持续研发投入，用前沿技术提升购彩体验。',
  valueService: '服务至上',
  valueServiceDesc: '7×24小时专业客服，用心服务每一位彩民。',
  valueSecurity: '安全第一',
  valueSecurityDesc: '银行级数据加密，全方位保障用户信息安全。',
  certTitle: '平台资质',
  cert1: '国家彩票销售许可',
  cert2: '信息系统安全等级保护三级',
  cert3: 'ISO 27001信息安全管理认证',
  cert4: 'AAA级信用企业认证',
  cert5: '网络文化经营许可证',
  statsTitle: '平台数据',
  contactTitle: '联系我们',
  contactSubtitle: '如有任何问题，欢迎随时与我们联系',
  contactAddress: '公司地址',
  contactAddressValue: '广东省广州市天河区珠江新城华夏路88号BB大厦28层',
  contactPhone: '客服热线',
  contactPhoneValue: '400-888-6666',
  contactEmail: '电子邮箱',
  contactEmailValue: 'service@bbcaipiao.com',
  contactHours: '服务时间',
  contactHoursValue: '周一至周日 7×24小时',
  formName: '您的姓名',
  formNamePlaceholder: '请输入您的姓名',
  formEmail: '电子邮箱',
  formEmailPlaceholder: '请输入您的电子邮箱',
  formPhone: '联系电话',
  formPhonePlaceholder: '请输入您的联系电话',
  formMessage: '留言内容',
  formMessagePlaceholder: '请输入您想咨询的问题或建议（限500字）',
  formSubmit: '提交留言',
  formSuccess: '留言提交成功！我们会尽快与您联系。',
  formError: '提交失败，请稍后再试。',
};

export default about;